import React, { useEffect, useState } from "react";
import SiderBar from "../../layouts/Frontend/GeneratalComponents/SideBarHeader";
import Headercomp from "./Components/Header";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { debugLog } from "../../utils/debug";  
import TopHeader from "../../layouts/Frontend/GeneratalComponents/TopHeader";
const DoctorLayout = ({ children }) => {

    //variable 
    const [showsiderbar, setShowSiderBar] = useState(false);
    const [logoutstatus, setLogoutStatus] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

    //function
    const handleClick = () => {
        if (showsiderbar == true) {
            setShowSiderBar(false);
            debugLog('handleClick : false');

        } else {
            setShowSiderBar(true);
            debugLog('handleClick : TRUE');
        }

    };

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 700);
            debugLog('Screen width:', width, 'isMobile:', width < 700);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <div className="row" style={{ width: '100%', marginLeft: '0px', marginRight: '0px' }}>
                {/* Mobile Overlay */}
                {isMobile ? (
                    showsiderbar ? (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 998,
                                transition: 'all 0.3s ease-in-out',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)'
                            }}
                        >
                            <div
                                id="dc-btnmenutoggle"
                                className="dc-btnmenutoggle"
                                style={{ display: 'block', marginLeft: '230px', zIndex: '9999' }}
                                onClick={handleClick} // ✅ Fixed here
                            >
                                <i className="ti-arrow-right"></i>
                            </div>
                            <div
                                style={{
                                    width: '250px',
                                    height: '100%',
                                    backgroundColor: 'white',
                                    boxShadow: '2px 0 5px rgba(0,0,0,0.2)',
                                    position: 'fixed',
                                    left: 0,
                                    top: 0,
                                    zIndex: 999,
                                    transition: 'all 0.3s ease-in-out'
                                }}
                            >
                                {/* Replace with your custom mobile menu */}
                                <SiderBar showsiderbar={showsiderbar} handleClick={handleClick} setLogoutStatus={setLogoutStatus} isMobile={isMobile} userType="doctor"/>
                                {/* Optional close button */}
                                
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                ) : (
                    <div
                        className={`leftsidebar `}
                        style={{
                            padding: '0px',
                            width: showsiderbar ? '50px' : '250px',
                            transition: 'all 0.3s ease-in-out',
                            position: 'relative',
                            height: '100vh',
                            zIndex: 999,
                            backgroundColor: 'white'
                        }}
                    >
                        <SiderBar showsiderbar={showsiderbar} handleClick={handleClick}  isMobile={isMobile} userType="doctor" />
                    </div>
                )}


                {/* Sidebar */}


                {/* Main Content */}
                <div
                    className={`rightsidebody col-lg-${showsiderbar == true ? '' : ''}`}
                    style={{
                        padding: '0px',
                        width: '0',
                        transition: 'all 0.3s ease-in-out',
                        // marginLeft: isMobile ? '0' : (showsiderbar == true ? '3.5%' : '20%')
                    }}
                >
                    <TopHeader showsiderbar={showsiderbar} setLogoutStatus={setLogoutStatus} isMobile={isMobile} userType="doctor" />
                    {children}
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} />

        </>
    );
};

export default DoctorLayout;
